var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 3.5625C11.3125 3.25184 11.5643 3 11.875 3C12.1857 3 12.4375 3.25184 12.4375 3.5625V8.0625H11.3125V3.5625Z",
    fill: "#8D33FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9444 6.96393C12.7279 7.06247 12.2858 7.21875 11.875 7.21875C11.4642 7.21875 11.0222 7.0625 10.8056 6.96396C10.2597 6.61398 9.56441 6.375 8.69623 6.375C5.65645 6.375 3.78582 8.90625 4.01965 12C4.25348 15.0938 5.89027 21 10.333 21C10.8537 21 11.3485 20.8761 11.875 20.4442C12.4015 20.8761 12.8963 21 13.417 21C17.8597 21 19.4965 15.0938 19.7303 12C19.9642 8.90625 18.0935 6.375 15.0538 6.375C14.1856 6.375 13.4903 6.61396 12.9444 6.96393Z",
    fill: "#FF8833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7145 4.15C15.6524 4.59817 15.2981 5.57224 14.378 5.88322C13.228 6.27192 12.4586 5.8913 12.2642 5.31631L12.2639 5.31641C12.0695 4.74134 12.4502 3.97192 13.6003 3.58319C14.5203 3.27224 15.3928 3.83152 15.7141 4.15012L15.7145 4.15Z",
    fill: "#8D33FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.c47ee69a565be7e2a5063bb66e80c490.svg";
export { ForwardRef as ReactComponent };